export default "__VITE_ASSET__DqlPN5_T__"